import { render, staticRenderFns } from "./rolemenu.vue?vue&type=template&id=20b9695d&scoped=true&"
import script from "./rolemenu.vue?vue&type=script&lang=js&"
export * from "./rolemenu.vue?vue&type=script&lang=js&"
import style0 from "./rolemenu.vue?vue&type=style&index=0&id=20b9695d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9695d",
  null
  
)

export default component.exports